import { QuestionMethods } from '../questionMethods.types';
import {
	SingleSelectGivenAnswer,
	RenderedSingleSelectQuestion,
} from './singleSelectMethods.types';

export const getSingleSelectAnswerListItems: QuestionMethods<
	RenderedSingleSelectQuestion,
	SingleSelectGivenAnswer
>['getAnswerListItems'] = ({ question, givenAnswers, answerListData }) => {
	const answerData = answerListData.single?.[question.id];
	if (answerData == null) return [];
	const givenAnswer = givenAnswers.single.get(question.id);
	if (givenAnswer == null) return [];

	const items = question.answers
		.filter((answer) => givenAnswer === answer.id)
		.map((answer) => {
			return {
				title: answer.title,
				explanation: answer.explanation,
			};
		});

	return items;
};
